import React from "react";
import { TextType } from "@baseTypes/baseType";
import { IconBox, Tooltip, Type as T } from "@infobis/ui-styles-utils";
import FlexLine from "../flexLine/FlexLine";
import st from './stickerHeader.module.scss';
import colors from "@infobis/ui-styles-utils/colors";
import cn from "classnames";

interface StickerHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  onClick?: () => void
  textType?: TextType
  isLink?: boolean
  hintText?: string
  rightPlacement?: () => string
}

const StickerHeader = ({title, onClick, textType, isLink = true, hintText = '', rightPlacement, ...rest}: StickerHeaderProps) => {
  return <FlexLine
    textType={textType}
    className={st['sticker-header']}
      {...rest}
  >
    <div className={st['sticker-header__link-wrapper']}>
      <div className={cn(st['sticker-header__link'], isLink && st['sticker-header__link--hover'])} onClick={onClick}>
        <span className={st.title}>
        {title}
       </span>
        {isLink &&
            <IconBox
                icon={T.IconName.ArrowRight}
                size={T.Size.MEDIUM}
                sizePadding={T.Size.SMALL}
                className={st.arrow}
            />
        }
      </div>
      {hintText &&
          <Tooltip
              text={hintText}
              trigger={'hover'}
              position={'top'}
          >
            <IconBox className={st['sticker-header__link-hint']}
                     icon={T.IconName.Info}
                     size={T.Size.LARGE}
                     color={colors.CONTROL_DEFAULT_ICON_ICON} />
          </Tooltip>
      }
    </div>

    <div>
      <span>{rightPlacement && rightPlacement()}</span>
    </div>
  </FlexLine>
}

export default StickerHeader
